import { LOYALTY_CATEGORIES_COLORS } from "./LoyaltyCategoriesColors";
import { i18nFilter } from "app/filters/i18nFilter";
import { percentageSignFilter } from "app/filters/ngFilters";

export const categoryLoyaltyTableBarChartAdaptor = (datum: any) => {
    if (!datum) {
        return undefined;
    }
    return Object.keys(datum).map((bucketName) => {
        return {
            backgroundColor: LOYALTY_CATEGORIES_COLORS[bucketName].backgroundColor,
            color: LOYALTY_CATEGORIES_COLORS[bucketName].color,
            name: i18nFilter()(`industry.analysis.loyalty.legend.${bucketName}`),
            text: percentageSignFilter()(datum?.[bucketName], 2),
            width: datum?.[bucketName],
        };
    });
};
